import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-box-wide__personalization-banner-wrapper product-box-wide__highlight-article-wrapper"
}
const _hoisted_2 = { class: "product-box-wide__highlight-article-badge" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "product-box-wide__personalization-banner-wrapper"
}
const _hoisted_6 = ["innerHTML"]

import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import {t} from '../../../bps/utilities/js/translations/translations';
  import {ProductBoxWideSettings} from './productBoxWideSettings';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBoxWideSegmentHeader',
  props: {
    productBoxData: {},
    settings: {}
  },
  setup(__props: any) {

  const props = __props;

  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);

return (_ctx: any,_cache: any) => {
  return (_unref(highlightArticleData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(highlightArticleData).text)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: _unref(highlightArticleData).text,
                class: "product-box-wide__highlight-article-text"
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (_unref(highlightArticleData).icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "product-box-wide__highlight-article-icon",
                src: _unref(highlightArticleData).icon,
                alt: "",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : (_ctx.settings.personalisationTop && _ctx.productBoxData.personalPreferenceMessageKey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "product-box-wide__personalization-banner personalization-banner",
            innerHTML: _unref(t)(_ctx.productBoxData.personalPreferenceMessageKey)
          }, null, 8 /* PROPS */, _hoisted_6)
        ]))
      : _createCommentVNode("v-if", true)
}
}

})